// src/components/AlertModal.js
import React from 'react';
import styles from '../styles/LoginModal.module.css'; // 复用 LoginModal 的样式

const AlertModal = ({ isOpen, message, onClose, onConfirm, confirmText = '确定' }) => {
  if (!isOpen) return null;

  // 默认关闭弹窗，如果传入 onConfirm，则执行自定义行为
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  // 将消息分割为段落数组
  const paragraphs = message ? message.split('\n') : [];

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.loginModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <button className={styles.closeBtn} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
          <h2>提示</h2>
          <div className={styles.messageContent}>
            {paragraphs.map((paragraph, index) => (
              <p key={index} className={styles.messageParagraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.btn} onClick={handleConfirm}>
            {confirmText} {/* 动态显示按钮文字 */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;